import { render, staticRenderFns } from "./item-product.vue?vue&type=template&id=26b38197&"
import script from "./item-product.vue?vue&type=script&lang=js&"
export * from "./item-product.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports